var map = {
	"./frontend/AndroidGuide.vue": 6880,
	"./frontend/Banking.vue": 1082,
	"./frontend/BetslipHistory.vue": 5514,
	"./frontend/BodyFB.vue": 8078,
	"./frontend/Commission.vue": 1033,
	"./frontend/ContactUs.vue": 9444,
	"./frontend/DataTable.vue": 6107,
	"./frontend/Deposit.vue": 3329,
	"./frontend/History.vue": 4503,
	"./frontend/Home.vue": 5987,
	"./frontend/IOSGuide.vue": 9787,
	"./frontend/Iframe copy.vue": 4670,
	"./frontend/Iframe.vue": 4099,
	"./frontend/Index.vue": 4833,
	"./frontend/Live.vue": 6765,
	"./frontend/LiveScore.vue": 2184,
	"./frontend/MainMenu.vue": 1087,
	"./frontend/MaungFB.vue": 4844,
	"./frontend/Promotion.vue": 2169,
	"./frontend/Setting.vue": 6300,
	"./frontend/VideoLink.vue": 6211,
	"./frontend/VipLevels.vue": 7583,
	"./frontend/Withdraw.vue": 3558,
	"./frontend/auth/Login.vue": 7739,
	"./frontend/auth/Register.vue": 467,
	"./frontend/auth/Rule.vue": 4557,
	"./frontend/auth/Verify.vue": 5819,
	"./frontend/auth/VerifyNotAuth.vue": 6671,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 2687,
	"./frontend/components/FBPreviewVoucher.vue": 9244,
	"./frontend/components/FBVoucher.vue": 9650,
	"./frontend/components/FootballTeamCard.vue": 2860,
	"./frontend/components/GroupBox.vue": 8747,
	"./frontend/components/InputSelectDrawModal.vue": 313,
	"./frontend/components/LuckyWheel.vue": 8290,
	"./frontend/components/NormalBox.vue": 3243,
	"./frontend/components/PreviewVoucher.vue": 5369,
	"./frontend/components/SideNav.vue": 850,
	"./frontend/components/Table.vue": 6459,
	"./frontend/components/ThreedGroupBox.vue": 5959,
	"./frontend/components/TwoDSelect.vue": 9795,
	"./frontend/components/UserDepositTable.vue": 5204,
	"./frontend/components/UserTransactions.vue": 8126,
	"./frontend/components/UserWithdrawTable.vue": 5717,
	"./frontend/components/Voucher.vue": 9780,
	"./frontend/normal-user/2d/2d.vue": 4306,
	"./frontend/normal-user/2d/ClosedDays.vue": 6899,
	"./frontend/normal-user/2d/Home.vue": 292,
	"./frontend/normal-user/2d/Winner.vue": 630,
	"./frontend/normal-user/3d/3d.vue": 3096,
	"./frontend/normal-user/3d/Home.vue": 6470,
	"./frontend/normal-user/DreamBooks.vue": 9062,
	"./frontend/normal-user/Index.vue": 6012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Arcade.vue": 6468,
	"./frontend/normal-user/game/Fishing.vue": 2983,
	"./frontend/normal-user/game/Game.vue": 1217,
	"./frontend/normal-user/game/Slot.vue": 7305,
	"./frontend/normal-user/shankomee/Room.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;